import { Fab, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import TaskItemLayer from "../components/task/TaskItemLayer";
import TaskService from "../APIService/TaskService";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../shared/loading";
import TaskItem, { TTaskItemProps } from "../components/task/TaskItem";
import { Task } from "@mui/icons-material";
import { MathJaxOutput } from "../components/mathJax/MathJaxOutput";
import reactStringReplace from "react-string-replace";
import { transformBrToNHelper } from "../helpers/transformBrToNHelper";
import classNames from "classnames";
import { QuestionImage } from "../components/task/QuestionImage";
import { CheckedCorrect, TCourse, TTask } from "../types";
import TaskList from "../components/task/TaskList";
import CourseService from "../APIService/CourseService";
import { useCourseContext } from "../context/courseContext";
import { useAuthContext } from "../context/authContext";
import { ym } from "react-metrika";
import { Button } from "../shared/button";
import InputAnswer from "../components/answer/InputAnswer";
import { AnswerTypeEnum } from "../enums";
import TaskEditButton from "../components/task/TaskEditButton";
import { isNoRoles } from "../helpers/role";
import RadioGroupAnswer from "../components/answer/RadioGroupAnswer";
import CheckboxGroupAnswer from "../components/answer/CheckboxGroupAnswer";
import { API_URL } from "../APIService";

export default OneTaskPage;

export function OneTaskPage(props: any) {
  const {
    setCourse,
    course,
    setTaskList,
    taskList,
    setCourseIds,
    courseIds,
    isCheckButtonDisabled,
  } = useCourseContext();
  const params = useParams();
  const [isCoursesLoading, setIsCoursesLoading] = useState<boolean>(false);
  // const { previousCourseId, nextCourseId } = useCourseNavigation(courseIds);
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.id) {
      setIsCoursesLoading(false);
      setTaskList([]);
      return;
    }

    const fetchCourse = async (id: number) => {
      setIsCoursesLoading(true);
      setTaskList([]);

      TaskService.getTask(id)
        .then((response) => {
          setCourse(response.data.course);
          setIsCoursesLoading(false);
          setTaskList(response.data.tasks);
          console.log("asdfasdfasdfasdfasd");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.statusCode == 404) navigate("/404");
        });
    };

    fetchCourse(Number.parseInt(params.id));
  }, [params.id, setTaskList, setCourse, setIsCoursesLoading]);

  return (
    <div className="Wrapper">
      {isCoursesLoading ? (
        <Loading />
      ) : (
        <TaskList2 tasks={taskList} course={course} />
      )}
    </div>
  );
}

type TTaskListProps = {
  tasks: TTask[];
  course: TCourse;
};

function TaskList2(props: TTaskListProps) {
  const { tasks, course } = props;

  const {
    handleSubmit,
    isClickedCheck,
    isCheckButtonDisabled,
    setCheckButtonDisabled,
    checkedTasks,
    answersList,
    resetAll,
  } = useCourseContext();

  const { authInfo } = useAuthContext();

  const [isCoursesLoading, setIsCoursesLoading] = useState<boolean>(false);

  if (course.title) {
    document.title = course.title.replace(/%course_id/g, course.id.toString());
  } else {
    const title = document.querySelector("title");
    if (title) {
      document.head.removeChild(title);
    }
  }

  const onClick = async (e: any) => {
    e.preventDefault();
    setIsCoursesLoading(true);
    await handleSubmit(e).then(() => {
      if (
        window.location.host !== "test.minimath239.ru" &&
        window.location.host !== "localhost:3000"
      ) {
        ym(102385331, "reachGoal", "btn_send_result");
      }
      setIsCoursesLoading(false);
    });
  };

  tasks.forEach((t, i) => {
    if (!t.rootId) {
      t.displayIndex = i + 1;
    }
  });

  const answeredTasksWithRoot = tasks.filter(
    (x) =>
      checkedTasks.map((z) => z.rootId).includes(x.id) ||
      checkedTasks.map((y) => y.taskId).includes(x.id),
  );

  const tasksToShow = !isClickedCheck ? tasks : answeredTasksWithRoot;

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   return () => {
  //     resetAll();
  //   };
  // }, [resetAll]);

  useEffect(() => {
    const somethingEntered = Object.keys(answersList).length
      ? Object.keys(answersList).reduce(
          (s, k) => (s += answersList[k].length),
          0,
        )
      : 0;
    setCheckButtonDisabled(!somethingEntered);
  }, [answersList, setCheckButtonDisabled]);

  if (!tasks) {
    return <h1 style={{ textAlign: "center" }}>Нет задач.</h1>;
  }

  return (
    <>
      {isCoursesLoading ? (
        <Loading />
      ) : (
        <div>
          {/* <TaskHeader
            course={course}
            isClickedCheck={isClickedCheck}
            authInfo={authInfo}
          /> */}

          <TaskItemLayer2
            checkedTasks={checkedTasks}
            isClickedCheck={isClickedCheck}
            tasksToShow={tasksToShow}
            answersList={answersList}
          />

          {isClickedCheck ? (
            <div className="TaskBackToTasksButton">
              <Button
                onClick={() => {
                  resetAll();
                }}
              >
                Вернуться к задаче
              </Button>
            </div>
          ) : (
            <div className="TaskButtonLayer">
              <Tooltip title={"Проверить ответ"}>
                <span>
                  <Fab
                    size="large"
                    variant="extended"
                    disabled={isCheckButtonDisabled}
                    sx={{
                      width: 300,
                      backgroundColor: "#EB5E70",
                      "&:hover": {
                        backgroundColor: "#EB5E70",
                        color: "#FFFFFF",
                      },
                    }}
                    onClick={onClick}
                    aria-label="save"
                  >
                    Проверить ответ
                  </Fab>
                </span>
              </Tooltip>
            </div>
          )}
          {/* <TaskFooter course={course} isClickedCheck={isClickedCheck} /> */}
        </div>
      )}
    </>
  );
}

export type TTaskLayerProps = {
  tasksToShow: TTask[];
  isClickedCheck: boolean;
  answersList: any;
  checkedTasks: any;
};

function TaskItemLayer2(props: TTaskLayerProps) {
  const { tasksToShow, isClickedCheck, answersList, checkedTasks } = props;
  let x = 1;
  return (
    <div>
      {tasksToShow.map((task) => (
        <div key={(x++).toString()}>
          <h1
            style={{
              fontSize: "36px",
              lineHeight: "37px",
              textAlign: "center",
              fontStyle: "normal",
              fontFamily: "Montserrat",
              fontWeight: "550",
            }}
          ></h1>

          <div
            style={{
              padding: "0.75rem",
              // border: "rgba(24, 51, 69, 0.3) solid thin",
              fontWeight: "500",
              wordWrap: "break-word",
            }}
          >
            <TaskItem2
              isCorrectlySolved={
                checkedTasks.find((x: any) => x.taskId === task.id)
                  ?.isCorrect === "CORRECT"
              }
              answerList={answersList}
              isCheckButtonClicked={isClickedCheck}
              checked={checkedTasks.find((x: any) => x.taskId === task.id)}
              task={task}
            />

            {task.subTasks ? (
              task.subTasks.map((subtask) => (
                <TaskItem2
                  key={(x++).toString()}
                  isCorrectlySolved={
                    checkedTasks.find((x: any) => x.taskId === subtask.id)
                      ?.isCorrect === "CORRECT"
                  }
                  answerList={answersList}
                  isCheckButtonClicked={isClickedCheck}
                  checked={checkedTasks.find(
                    (x: any) => x.taskId === subtask.id,
                  )}
                  task={subtask}
                />
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function TaskItem2(props: TTaskItemProps) {
  const { task, checked, answerList, isCheckButtonClicked, isCorrectlySolved } =
    props;
  const defaultWidth = 80;
  const maxWidth = 300;
  const [inputWidth, setInputWidth] = useState(defaultWidth);

  const expandShrinkField = (e: any) => {
    let length = e.target.value.length;
    if (length === 0) {
      setInputWidth(defaultWidth);
    }
    if (inputWidth <= maxWidth && e.target.value.length * 10 >= inputWidth) {
      setInputWidth(defaultWidth + e.target.value.length * 5);
    }
  };

  const mask = task.answerMask || "";

  const inputAlgAndRegexp = () => {
    let count = -1;

    const onChange = (e: any) => {
      handleChange(e);
      expandShrinkField(e);
    };

    const onChangeRationals = (e: any) => {
      if (RegExp("[^0-9,;\/\-]", "i").exec(e.target.value)) return;
      handleChange(e);
      expandShrinkField(e);
    };

    const onChangeInts = (e: any) => {
      if (RegExp("[^0-9;\-]", "i").exec(e.target.value)) return;
      handleChange(e);
      expandShrinkField(e);
    };

    return (
      <MathJaxOutput
        text={reactStringReplace(
          transformBrToNHelper(mask),
          /(%d|%s|%i)/g,
          (match: string, i: number) => {
            count++;
            const elementId = "id" + task.id + "_" + count;
            return (
              <div
                key={elementId}
                className={classNames(["TaskRegExpAnswer", "w-25"])}
              >
                <InputAnswer
                  value={answerList[elementId] || ""}
                  disabled={isCheckButtonClicked}
                  key={elementId}
                  id={elementId}
                  onChange={
                    match === "%d"
                      ? onChangeRationals
                      : match === "%i"
                        ? onChangeInts
                        : onChange
                  }
                  inputwidth={inputWidth}
                />
              </div>
            );
          },
        )}
      />
    );
  };

  const inputSimpleAlg2Nospaces = (
    label?: string,
    defaultAnswer?: any,
    allowedChars?: string,
  ) => {
    const s = allowedChars ? allowedChars : "[^0-9,;\/\-]";

    const onChange2 = (e: any) => {
      if (RegExp(s, "i").exec(e.target.value)) return;
      handleChange(e);
      expandShrinkField(e);
    };

    return (
      <div key={task.id} className={classNames(["TaskRegExpAnswer", "w-75"])}>
        <InputAnswer
          disableunderline="true"
          value={
            answerList["id" + task.id]
              ? answerList["id" + task.id]
              : defaultAnswer || ""
          }
          disabled={isCheckButtonClicked}
          id={"id" + task.id}
          placeholder={label}
          onChange={onChange2}
        />
      </div>
    );
  };

  const { handleChange } = useCourseContext();
  const { authInfo } = useAuthContext();

  const correct = checked && checked.isCorrect === CheckedCorrect.CORRECT;
  const hintStyle = correct ? "TaskHintCorrect" : "TaskHintWrong";
  const answerStyle =
    isCheckButtonClicked && checked
      ? correct
        ? "TaskAnswerBlockCorrect"
        : "TaskAnswerBlockWrong"
      : task.answerType == AnswerTypeEnum.NONE
        ? "TaskAnswerBlockNoBorder"
        : "TaskAnswerBlock";

  return (
    <div className="TaskInnerLayout1">
      <div className="TaskInformation">
        <QuestionImage task={task} maxWidth={maxWidth} maxHeight={400} />

        <MathJaxOutput text={transformBrToNHelper(task.question)} />

        <p key={task.id} className="TaskTaskCode">
          (код задачи: {task.id})
          <TaskEditButton access={authInfo.role} id={task.id} />
        </p>
      </div>

      <div key={"id" + task.id} className="TaskTask">
        <h2>Ответ:</h2>
        {isNoRoles(authInfo.role) &&
        (task.isAlreadySolved ||
          (!isCheckButtonClicked && isCorrectlySolved)) ? (
          <div
            className={
              task.answerType == AnswerTypeEnum.NONE
                ? "TaskAnswerBlockNoBorder"
                : "TaskAnswerBlock"
            }
          >
            <p className="TaskAlreadySolved">Правильно решено ранее.</p>
          </div>
        ) : (
          <div key={"id" + task.id} className={answerStyle}>
            {(() => {
              switch (task.answerType) {
                case AnswerTypeEnum.RADIO:
                  return (
                    <RadioGroupAnswer
                      answer={answerList["id" + task.id]}
                      disabled={isCheckButtonClicked}
                      key={task.id}
                      id={"id" + task.id}
                      answerlist={task.answerMask.split(";")}
                      onChange={handleChange}
                    />
                  );

                case AnswerTypeEnum.CHECKBOX:
                  return (
                    <CheckboxGroupAnswer
                      answer={answerList["id" + task.id]}
                      disabled={isCheckButtonClicked}
                      key={task.id}
                      id={"id" + task.id}
                      answerlist={task.answerMask.split(";")}
                      onChange={handleChange}
                    />
                  );

                case AnswerTypeEnum.SIMPLE:
                  return (
                    <div className="TaskAnswerArea">
                      {inputSimpleAlg2Nospaces("Ответ")}
                    </div>
                  );

                case AnswerTypeEnum.ALG:
                case AnswerTypeEnum.REG_EXP:
                  return (
                    <div className="TaskAnswerArea">{inputAlgAndRegexp()}</div>
                  );

                case AnswerTypeEnum.ALG2:
                  return (
                    <div className="TaskAnswerArea">
                      {inputSimpleAlg2Nospaces("Ответ через ;")}
                    </div>
                  );

                case AnswerTypeEnum.NO_SPACES:
                  return (
                    <div className="TaskAnswerArea">
                      {inputSimpleAlg2Nospaces(
                        "Введите выражение",
                        task.answerMask,
                        "[^0-9a-z ,а-яА-Я;\/\+\*\=\-]",
                      )}
                    </div>
                  );
                default: {
                  return <div className="TaskAnswerArea"></div>;
                }
              }
            })()}
            {task.isAlreadySolved ||
            (!isCheckButtonClicked && isCorrectlySolved) ? (
              <p className="TaskAlreadySolvedSmall">Правильно решено ранее.</p>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>

      {isCheckButtonClicked && checked ? (
        <div className={hintStyle}>
          {correct && checked.solutionImage ? (
            <p>
              <img
                src={API_URL + "image" + checked.solutionImage}
                alt={checked.solutionImage}
              />
            </p>
          ) : (
            <></>
          )}
          {checked.hint
            ? checked.hint.map((h) => (
                <div>
                  {h.image && h.image.length > 0 ? (
                    <p>
                      <img src={API_URL + "image" + h.image} alt={h.image} />
                    </p>
                  ) : null}
                  {h.note ? (
                    <p>
                      <MathJaxOutput text={h.note} />
                    </p>
                  ) : null}
                </div>
              ))
            : null}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
